import { takeLatest } from 'redux-saga/effects'

import workRefusalRequestsAPI from 'api/laborerPortalAPI/workRefusalRequests'
import {
  approveWorkRefusalRequest as approveWorkRefusalRequestAction,
  getWorkRefusalRequestDetails as getWorkRefusalRequestDetailsAction,
  getWorkRefusalRequests as getWorkRefusalRequestsAction,
  rejectWorkRefusalRequest as rejectWorkRefusalRequestAction,
} from 'redux/actionCreators/laborerPortalAPI/workRefusalRequests'
import Actions from 'redux/actions'
import { getSimpleRequestHandler } from 'saga/utils'

const getWorkRefusalRequests = getSimpleRequestHandler<
  typeof workRefusalRequestsAPI.getWorkRefusalRequests,
  ReturnType<typeof getWorkRefusalRequestsAction>
>({
  actionLoading: Actions.GET_LABORER_WORK_REFUSAL_REQUESTS_ASYNC,
  actionSuccess: Actions.GET_LABORER_WORK_REFUSAL_REQUESTS_SUCCESS,
  actionFail: Actions.GET_LABORER_WORK_REFUSAL_REQUESTS_FAIL,
  callApiFn: workRefusalRequestsAPI.getWorkRefusalRequests,
})

const getWorkRefusalRequestDetails = getSimpleRequestHandler<
  typeof workRefusalRequestsAPI.getWorkRefusalRequestDetails,
  ReturnType<typeof getWorkRefusalRequestDetailsAction>
>({
  actionLoading: Actions.GET_LABORER_WORK_REFUSAL_REQUEST_DETAILS_ASYNC,
  actionSuccess: Actions.GET_LABORER_WORK_REFUSAL_REQUEST_DETAILS_SUCCESS,
  actionFail: Actions.GET_LABORER_WORK_REFUSAL_REQUEST_DETAILS_FAIL,
  callApiFn: workRefusalRequestsAPI.getWorkRefusalRequestDetails,
})

const approveWorkRefusalRequest = getSimpleRequestHandler<
  typeof workRefusalRequestsAPI.approveWorkRefusalRequest,
  ReturnType<typeof approveWorkRefusalRequestAction>
>({
  actionLoading: Actions.APPROVE_LABORER_WORK_REFUSAL_REQUEST_ASYNC,
  actionSuccess: Actions.APPROVE_LABORER_WORK_REFUSAL_REQUEST_SUCCESS,
  actionFail: Actions.APPROVE_LABORER_WORK_REFUSAL_REQUEST_FAIL,
  callApiFn: workRefusalRequestsAPI.approveWorkRefusalRequest,
})

const rejectWorkRefusalRequest = getSimpleRequestHandler<
  typeof workRefusalRequestsAPI.rejectWorkRefusalRequest,
  ReturnType<typeof rejectWorkRefusalRequestAction>
>({
  actionLoading: Actions.REJECT_LABORER_WORK_REFUSAL_REQUEST_ASYNC,
  actionSuccess: Actions.REJECT_LABORER_WORK_REFUSAL_REQUEST_SUCCESS,
  actionFail: Actions.REJECT_LABORER_WORK_REFUSAL_REQUEST_FAIL,
  callApiFn: workRefusalRequestsAPI.rejectWorkRefusalRequest,
})

export default [
  takeLatest(Actions.GET_LABORER_WORK_REFUSAL_REQUESTS, getWorkRefusalRequests),
  takeLatest(Actions.GET_LABORER_WORK_REFUSAL_REQUEST_DETAILS, getWorkRefusalRequestDetails),
  takeLatest(Actions.APPROVE_LABORER_WORK_REFUSAL_REQUEST, approveWorkRefusalRequest),
  takeLatest(Actions.REJECT_LABORER_WORK_REFUSAL_REQUEST, rejectWorkRefusalRequest),
]
